import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSimilarEventsQuery } from 'queries/events';
import ExpandText from 'components/ExpandText/ExpandText';
import { dayjs } from 'lib/dayjs';
import ExternalLink from 'components/ExternalLink/ExternalLink';
import { EVENT_PAGE } from 'config/paths';
import { useDatesHelper } from '@shape/lighthouse-components';

interface SimilarEventProps {
  assetId: string;
  eventId: string;
}

const SimilarEvent: React.FC<SimilarEventProps> = ({ eventId, assetId }) => {
  const { t } = useTranslation();
  const { buildDateRange } = useDatesHelper();
  const defaultPeriod = buildDateRange('365');
  const { data } = useSimilarEventsQuery({
    assetId,
    eventId,
    end_date: defaultPeriod.endDate,
    start_date: defaultPeriod.startDate,
  });

  const event = data?.events.filter((event) => event.event_id !== eventId)[0];
  const useful = event?.classification
    ? `${t(`event_page:chart_status.classification.${event?.classification}`)}. `
    : '';

  return (
    <ExpandText
      text={
        event
          ? t(`event_page:components:similarEvents.text`, {
              eventDate: dayjs(event.start_date).format(t('formats:date.datetime_minute')),
              eventComments: event.comments,
              useful,
            })
          : t(`event_page:components:similarEvents.no_data`)
      }
    >
      {event && (
        <ExternalLink
          className="similar-event-link"
          url={`${EVENT_PAGE(event.event_id)}`}
          label={t(`event_page:components:similarEvents.button`)}
        />
      )}
    </ExpandText>
  );
};

export default SimilarEvent;
